(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-slider"] && !Shopify.designMode) return;
  try {
    
  class PressSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-press-track]');
      this.prev = this.querySelector('[data-press-prev]');
      this.next = this.querySelector('[data-press-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    step() {
      const card = this.track.querySelector('.press-card');
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prev.disabled = this.track.scrollLeft <= 0;
      this.next.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('press-slider')) {
    customElements.define('press-slider', PressSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-slider"] && !Shopify.designMode) return;
  try {
    
  class ResourcesSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-resources-track]');
      this.prev = this.querySelector('[data-resources-prev]');
      this.next = this.querySelector('[data-resources-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    step() {
      const card = this.track.querySelector('.jrn-resource-card');
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prev.disabled = this.track.scrollLeft <= 0;
      this.next.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('resources-slider')) {
    customElements.define('resources-slider', ResourcesSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
